<template>
  <div v-if="label">
    <BaseEditLabel :label="label" :required="required" />
  </div>
  <div class="inline-flex overflow-hidden rounded-md border" role="group">
    <button
      v-for="(option, index) in options"
      :key="index"
      type="button"
      :class="[
        option[trackBy] == selectedValues
          ? 'text-contrast-primary'
          : 'focus:bg-primary-100 enabled:hover:bg-primary-100 active:enabled:bg-primary-100 bg-white dark:bg-slate-800',
        option.bgClass && option[trackBy] == selectedValues
          ? option.bgClass
          : 'bg-primary-500 focus:bg-primary-400 enabled:hover:bg-primary-500 enabled:hover:text-contrast-primary active:enabled:bg-primary-400',
        buttonClass,
        wFull ? 'flex-1' : ''
      ]"
      class="px-4 py-2 text-sm font-medium outline-0 disabled:cursor-not-allowed"
      @click="() => (selectedValues = option[trackBy])"
    >
      <FontAwesomeIcon :icon="option.icon" />
    </button>
  </div>
</template>

<script>
import BaseEditLabel from '@c/addf-package/components/BaseLabel/BaseEditLabel'
import { computed } from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'WalkmanButtonIcon',
  components: { FontAwesomeIcon, BaseEditLabel },
  props: {
    modelValue: {
      type: [String, Boolean],
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    label: {
      type: String,
      required: false,
      default: null
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    trackBy: {
      type: String,
      required: false,
      default: 'value'
    },
    attributeLabel: {
      type: String,
      required: false,
      default: 'label'
    }
  },
  emits: ['update:modelValue', 'change'],
  setup(props, { emit }) {
    const selectedValues = computed({
      get: () => props.modelValue,
      set: (value) => {
        emit('update:modelValue', value)
        emit('change', value)
      }
    })
    return { selectedValues }
  }
}
</script>
